import React from "react";
import styled from "styled-components";
import { colors, media, spacing } from "../theme";
import {
  DEFAULT_PADDING,
  DEFAULT_PADDING_MOBILE_ZOOM
} from "../common/Content";

const Box = styled.div`
  background-color: ${colors.paleGreyTwo};
  padding: 0 ${DEFAULT_PADDING};
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${media.mobile} {
    width: auto;
    margin-left: -${DEFAULT_PADDING};
    margin-right: -${DEFAULT_PADDING};
  }
  @media ${media.superTinyZoom125} {
    width: auto;
    margin-left: -${DEFAULT_PADDING_MOBILE_ZOOM};
    margin-right: -${DEFAULT_PADDING_MOBILE_ZOOM};
  }
`;
const InnerBox = styled.div`
  ${spacing("margin-top", 120)}
  ${spacing("margin-bottom", 120)}
  width:100%;
`;

const FormBox: React.FC = ({ children }) => {
  return (
    <Box>
      <InnerBox>{children}</InnerBox>
    </Box>
  );
};
export default FormBox;
